import styled from "styled-components";

export const HeaderWrapper = styled.div`
  position: sticky;
  top: 0;
  width: 100%;
  z-index: 2;
`;
export const HeroArea = styled.div`
  position: relative;
`;
export const SearchFromArea = styled.div`
  border-radius: 8px;
  box-shadow: rgba(0, 0, 0, 0.08) 0px 8px 30px;
  background: white;
  max-width: 1100px;
  width: 100%;
  left: 50%;
  position: absolute;
  bottom: 0;
  transform: translate(-50%, 50%);
  z-index: 5;
  
  @media (max-width: 1024px) {
    position: relative;
    left: auto;
    bottom: auto;
    transform: none;
    margin: -50px auto 30px auto;
    width: 92%;
  }
`;
